import { render } from "./CustomerAddEdit.vue?vue&type=template&id=ddaaa914&scoped=true"
import script from "./CustomerAddEdit.vue?vue&type=script&lang=js"
export * from "./CustomerAddEdit.vue?vue&type=script&lang=js"

import "./CustomerAddEdit.vue?vue&type=style&index=0&id=ddaaa914&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddaaa914"]])

export default __exports__